import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectors } from "reducers";
import * as R from "ramda";

const PatientTypeOutreachCoachFilter = ({
  setFilters,
  patientType,
  filters,
  patientTypeCoachOptions = []
}) => {
  const selectedSleepCoaches = R.propOr([], `${patientType?.toLowerCase()}_coach`, filters);
  const [searchResultsCoach, setSearchResultsCoach] = useState([]);
  const [searchTerms, setSearchTerms] = useState("");

  useEffect(()=>{
    if(searchTerms !== ""){
      setSearchResultsCoach(patientTypeCoachOptions.filter(sco=> sco.name.toLowerCase().includes(searchTerms.toLowerCase())))
    }
    else{
      setSearchResultsCoach(patientTypeCoachOptions)
    }
  }, [searchTerms])


  return (
    <React.Fragment>
        <div
            onClick={() => {
            setFilters("patient_type_coach");
            }}
            className="filter-pane-command controls"
            >
            Clear Selections
        </div>
        <input
            type="text"
            className="searchInputBox-coachfilter"
            onChange={(e) => {setSearchTerms(e.target.value)}}
            placeholder="Search By Coach"
        >
        </input>
        {
            searchResultsCoach.map(sco => (
              <div key={sco.value}>
                <label className="filter-entry filter-sub-entry">
                  <input
                    type="checkbox"
                    checked={selectedSleepCoaches.includes(sco.value)}
                    onChange={({ target }) => {
                      if (target.checked) {
                        setFilters(
                          `${patientType?.toLowerCase()}_coach`,
                          R.uniq(R.append(sco.value, selectedSleepCoaches))
                        );
                      } else {
                        setFilters(
                          `${patientType?.toLowerCase()}_coach`,
                          R.without([sco.value], selectedSleepCoaches)
                        );
                      }
                    }}
                  />
                  {sco.text}
                </label>
              </div>
            ))
        }
    </React.Fragment>
  );
};

export default connect((state, props) => ({
  filters: selectors.getQueryFilters(state, props.queryId)
}))(PatientTypeOutreachCoachFilter);

PatientTypeOutreachCoachFilter.propTypes = {
  queryId: PropTypes.string.isRequired,
  patientType: PropTypes.string.isRequired,
  setFilters: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  patientTypeCoachOptions: PropTypes.arrayOf(PropTypes.object)
};
